export enum Role {
  Admin = 'Admin',
  Publisher = 'Publisher',
  Editor = 'Editor'
}
